module.exports = __webpack_public_path__ + "static/media/paac.3c9b3577.png";